module.exports = __webpack_public_path__ + "img/ripples.a1b802b82b10b11487e9b3151ace604a.jpg";